import React from "react";
import { Box, Typography, Link } from "@mui/material";

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        pt: 2,
        mt: 2,
        backgroundColor: "#afca0b",
        textAlign: "center",
      }}
    >
      <Typography
        variant="body2"
        color="white"
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: 1,
        }}
      >
        Copyright © 1997–2025 Związek Harcerstwa Polskiego&nbsp;|&nbsp;
        <Link
          href="https://zhp.pl/informacje-i-uwagi-prawne/"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          color="inherit"
        >
          Informacje i uwagi prawne
        </Link>
        &nbsp;|&nbsp;
        <Link
          href="https://zhp.pl/rodo/"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          color="inherit"
        >
          Polityka prywatności
        </Link>
        &nbsp;|&nbsp;
        <Link
          href="https://bip.zhp.pl"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          color="inherit"
        >
          Biuletyn Informacji Publicznej
        </Link>
      </Typography>
    </Box>
  );
}
